import { ERROR_MESSAGES } from './events.config';

export type ThrottleCallback = (...args: unknown[]) => void;

/**
 * @name throttle
 *
 * @description Throttle events or anything else that needs to be throttled
 *
 * @param {number} limit
 * @param {ThrottleCallback} callback
 *
 * @returns return a throttle function which executes the callback when limit is reached
 */
export function throttle(limit: number, callback: ThrottleCallback) {
  if (typeof callback !== 'function') {
    throw new Error(ERROR_MESSAGES.callbackNeedToBeFunction);
  }

  let lastFunc: number;
  let lastRan: number;

  return function(this: unknown, ...args: unknown[]) {
    if (!lastRan) {
      callback.apply(this, args);
      lastRan = Date.now();
    } else {
      // need to use the window's function otherwise
      // TS2322: Type 'Timeout' is not assignable to type 'number'
      window.clearTimeout(lastFunc);
      lastFunc = window.setTimeout(() => {
        if (Date.now() - lastRan >= limit) {
          callback.apply(this, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}
